import React, { useContext, useEffect, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Spin } from 'antd';
import queryString from 'query-string';
import { AppContext } from 'context/AppContext';
import { getMyMarketplaceSubscriptions } from 'marketplace/apps/owner-reporting/api/marketplace';
import PayoutV2 from 'marketplace/apps/owner-reporting/pages/PayoutV2';
import {
  buildOwnerReportingV1RedirectTo,
  shouldHideV1OwnerPages,
  shouldRedirectV1Host,
  shouldShowOwnerPayoutV2,
} from 'marketplace/core/ownerReportingReplacesV1';
import Payout from './Payout';

const readIsOwner = () => {
  try {
    const authObj = JSON.parse(localStorage.getItem('auth') || 'null');
    if (!authObj || !authObj.user || authObj.user.isAdmin) return false;
    const roles = authObj.user.roles || [];
    return !!(roles[0] && roles[0].name === 'Owner');
  } catch (e) {
    return false;
  }
};

const PayoutEntryInner = props => {
  const { location } = props;
  const { getUserHosts, checkIsAdmin } = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [mode, setMode] = useState('v1');
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const isAdmin = !!(checkIsAdmin && checkIsAdmin());
      const isOwner = readIsOwner();
      const userHostIds = (getUserHosts && getUserHosts()) || [];
      const parsed = queryString.parse((location && location.search) || '');
      const rawHost = parsed.host || parsed.hostId;
      const queryHost = Array.isArray(rawHost) ? rawHost[0] : rawHost;

      try {
        if (isAdmin) {
          if (!cancelled) {
            setRedirectTo(null);
            setMode('v1');
            setReady(true);
          }
          return;
        }

        const mine = await getMyMarketplaceSubscriptions();
        const subscriptions = Array.isArray(mine) ? mine : [];

        if (
          shouldShowOwnerPayoutV2({
            isOwner,
            hostId: queryHost,
            userHostIds,
            subscriptions,
          })
        ) {
          if (!cancelled) {
            setRedirectTo(null);
            setMode('v2');
            setReady(true);
          }
          return;
        }

        if (!isOwner) {
          if (queryHost && shouldRedirectV1Host({ hostId: queryHost, subscriptions, isAdmin })) {
            if (!cancelled) {
              setMode('redirect');
              setRedirectTo(
                buildOwnerReportingV1RedirectTo({
                  pathname: (location && location.pathname) || '/payout',
                  hostId: queryHost,
                })
              );
              setReady(true);
            }
            return;
          }
          if (shouldHideV1OwnerPages({ userHostIds, subscriptions, isAdmin })) {
            if (!cancelled) {
              setMode('redirect');
              setRedirectTo(
                buildOwnerReportingV1RedirectTo({
                  pathname: (location && location.pathname) || '/payout',
                  hostId: queryHost || userHostIds[0],
                })
              );
              setReady(true);
            }
            return;
          }
        }
      } catch (e) {
        // Fail open to v1 payout.
      }

      if (!cancelled) {
        setRedirectTo(null);
        setMode('v1');
        setReady(true);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [location && location.pathname, location && location.search, getUserHosts, checkIsAdmin]);

  if (!ready) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin />
      </div>
    );
  }

  if (mode === 'redirect' && redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  if (mode === 'v2') {
    return <PayoutV2 />;
  }

  return <Payout {...props} />;
};

export default withRouter(PayoutEntryInner);
